import { render, staticRenderFns } from "./EmployeeDetailsCard.vue?vue&type=template&id=11747823&scoped=true&"
import script from "./EmployeeDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeDetailsCard.vue?vue&type=style&index=0&id=11747823&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11747823",
  null
  
)

export default component.exports